"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var stableSort_1 = __importDefault(require("./stableSort"));
var getSorting_1 = __importDefault(require("./getSorting"));
function filterNotes(notes, filters, order) {
    var filteredNotes = notes;
    var _a = filters.category, category = _a === void 0 ? null : _a, _b = filters.subcategories, subcategories = _b === void 0 ? [] : _b, _c = filters.starred, starred = _c === void 0 ? false : _c;
    // Filter notes by category
    if (category) {
        filteredNotes = filteredNotes.filter(function (note) { return note.category === category; });
    }
    // Filter notes by subcategory
    if (subcategories && subcategories.length) {
        filteredNotes = filteredNotes.filter(function (note) {
            return note.subcategories.filter(function (subcategory) {
                return subcategories.includes(subcategory);
            }).length;
        });
    }
    // Include starred notes
    if (starred) {
        filteredNotes = filteredNotes.filter(function (note) { return note.starred; });
    }
    if (order) {
        return stableSort_1.default(filteredNotes, getSorting_1.default(order.order, order.orderBy));
    }
    return filteredNotes;
}
exports.default = filterNotes;
//# sourceMappingURL=filterNotes.js.map